import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "cs"], // Supported locales
  defaultLocale: "cs", // Default locale
  localePrefix: "always",
  localeDetection: false,
  // Page metadata and sitemap already emit localized alternate URLs with
  // translated slugs. The generic middleware header only mirrors the current
  // slug across locales, which creates broken hreflang targets.
  alternateLinks: false,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
